<template>
  <div>
    <div
      id="modal-title"
      class="modal-header"
    >
      <h2>Adicionar Web Hook</h2>
    </div>
    <div class="modal-content">
      <form id="form-add-hook">
        <div class="input-group">
          <div class="input input-text">
            <label :for="webHook.channel">Canal</label>
            <input
              :id="webHook.channel"
              v-model="webHook.channel"
              placeholder="ticketing-events"
              type="text"
            >
          </div>
          <div class="input input-text">
            <label :for="webHook.id">WebHook</label>
            <input
              :id="webHook.id"
              v-model="webHook.id"
              placeholder="or87kjy8df85p81z6oin6tshkr"
              type="text"
            >
          </div>
        </div>

        <div class="form-actions">
          <button
            type="button"
            class="btn-secondary"
            @click="close"
          >
            {{ $t('cancel') }}
          </button>
          <button
            type="button"
            class="btn-primary btn-active main-action"
            :class="{ disabled: disableSubmit }"
            @click="createNotifier()"
          >
            {{ $t('create') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import notifiersApi from '@/api/notifiers'

export default {
  name: 'CreateNotifier',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    notifier: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      webHook: {
        channel: '',
        id: ''
      }
    }
  },
  computed: {
    ...mapState([
      'services'
    ]),
    disableSubmit () {
      return !this.type || !this.service
    }
  },
  created () {
    this.fetchServices()
  },
  methods: {
    async close () {
      this.$emit('input', false)
    },
    ...mapActions([
      'fetchServices',
      'fetchCurrentTickets'
    ]),
    async createNotifier () {
      console.log(this.notifier)
      this.notifier.webHooks.push(this.webHook)
      notifiersApi.updateNotifier(this.notifier)
      console.log(this.notifier)
      this.close()
    }
  }
}
</script>
